export default function Layout({ children }: { children: any }) {
  return (
    <main>{children}</main>
  );
}
